import { ServiceRequestDetailsScreen } from '@/modules/support/components/ServiceRequestDetailsScreen';
import { useLocalSearchParams } from 'expo-router';
import React from 'react';

export default function ServiceRequestDetailsRoute() {
    const params = useLocalSearchParams<{
        id?: string;
        title?: string;
        category?: string;
        status?: string;
        createdAt?: string;
        description?: string;
        caseNumber?: string;
        unit?: string;
    }>();

    return (
        <ServiceRequestDetailsScreen
            id={params.id || ''}
            title={params.title || ''}
            category={params.category || ''}
            status={params.status ? String(params.status) : 'in-progress'}
            createdAt={params.createdAt || ''}
            description={params.description ? String(params.description) : ''}
            caseNumber={params.caseNumber ? String(params.caseNumber) : ''}
            unit={params.unit ? String(params.unit) : ''}
        />
    );
}


